module.exports = __webpack_public_path__ + "img/Meeting.28d02c26.jpg";